define("Bazaarvoice.Shopping", [
  "Bazaarvoice",
  "Bazaarvoice.PDP.RatingSummary.View",
  "Bazaarvoice.PDP.Reviews.View",
  "Bazaarvoice.PDP.Questions.View",
  "Bazaarvoice.PLP.InlineRatings.View",
  "underscore",
], function (
  Bazaarvoice,
  BazaarvoicePDPRatingSummaryView,
  BazaarvoicePDPReviewsView,
  BazaarvoicePDPQuestionsView,
  BazaarvoicePLPInlineRatingsView,
  _
) {
  "use strict";

  var BAZAARVOICE_VIEWS = [
    {
      name: "Bazaarvoice.PDP.RatingSummary",
      instance: BazaarvoicePDPRatingSummaryView,
    },
    {
      name: "Bazaarvoice.PDP.Reviews",
      instance: BazaarvoicePDPReviewsView,
    },
    {
      name: "Bazaarvoice.PDP.Questions",
      instance: BazaarvoicePDPQuestionsView,
    },
    {
      name: "Bazaarvoice.PLP.InlineRatings",
      instance: BazaarvoicePLPInlineRatingsView,
    },
  ];

  return {
    mountToApp: function (container) {
      // Common operations
      Bazaarvoice.mountToApp(container);
      // Adding bazaar views for PDP and PLP
      this.addBazaarvoiceViews(container);
    },

    addBazaarvoiceViews: function (container) {
      var layout = container.getComponent("Layout");

      if (!layout) {
        return;
      }

      _.each(BAZAARVOICE_VIEWS, function (view) {
        layout.addChildView(view.name, function () {
          return new view.instance({
            container: container,
          });
        });
      });
    },
  };
});
